export default __webpack_public_path__ + "static/media/top-marleen.255ba2df.jpeg";